export const QueryKey = {
  CONTRACT_ID: "cr",
  INQUIRY_ID: "iq",
  CUSTOMER_ID: "cm",
  INVALID_STATUS: "st",
  SHOP_SELECTION: "sp",
  PROPERTY_TYPE: "tp",
  APARTMENT_NAME: "ms",
  PREFECTURE: "pf",
  CITY: "ct",
  TOWN: "tw",
  TRAFFIC_SOURCE: "ts",
  MONTHLY_LIMIT: "ml",
} as const;

export type IQueryKey = typeof QueryKey[keyof typeof QueryKey];

export default QueryKey;
